<ion-list>
  <ion-item *ngFor="let item of priorityItems">
    <ion-checkbox [(ngModel)]="item.checked">{{ item.label }}</ion-checkbox>
  </ion-item>
</ion-list>
